import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ExternalLink, X } from "lucide-react";
import { getActivePromos, type SitePromo } from "@/data/promos";
import { trackAffiliateClick, trackPromoClick, trackPromoDismiss, trackPromoImpression } from "@/lib/analytics";
import { t, type SupportedLocale } from "@/lib/i18n";
import { dismissPromo, isPromoDismissed } from "@/lib/promoPreference";
import styles from "@/styles/PromoBanner.module.css";
function PromoBannerItem(t0) {
  const $ = _c(54);
  const {
    promo,
    locale
  } = t0;
  const [visible, setVisible] = useState(false);
  let t1;
  let t2;
  if ($[0] !== promo.id) {
    t1 = () => {
      if (isPromoDismissed(promo.id)) {
        return;
      }
      setVisible(true);
      trackPromoImpression(promo.id);
    };
    t2 = [promo.id];
    $[0] = promo.id;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!visible) {
    return null;
  }
  let t3;
  if ($[3] !== promo.href || $[4] !== promo.id || $[5] !== promo.partnerId) {
    t3 = () => {
      trackPromoClick(promo.id);
      trackAffiliateClick({
        partnerId: promo.partnerId,
        partnerLabel: "YourWobb promo",
        destinationUrl: promo.href,
        context: "promo_banner"
      });
    };
    $[3] = promo.href;
    $[4] = promo.id;
    $[5] = promo.partnerId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onClick = t3;
  let t4;
  if ($[7] !== promo.id) {
    t4 = () => {
      trackPromoDismiss(promo.id);
      dismissPromo(promo.id);
      setVisible(false);
    };
    $[7] = promo.id;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onDismiss = t4;
  let t5;
  if ($[9] !== locale || $[10] !== promo.ariaKey) {
    t5 = t(locale, promo.ariaKey);
    $[9] = locale;
    $[10] = promo.ariaKey;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== locale || $[13] !== promo.titleKey) {
    t6 = t(locale, promo.titleKey);
    $[12] = locale;
    $[13] = promo.titleKey;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <p className={styles.title}>{t6}</p>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== locale || $[18] !== promo.bodyKey) {
    t8 = t(locale, promo.bodyKey);
    $[17] = locale;
    $[18] = promo.bodyKey;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <p className={styles.body}>{t8}</p>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== locale || $[23] !== promo.periodKey) {
    t10 = t(locale, promo.periodKey);
    $[22] = locale;
    $[23] = promo.periodKey;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10) {
    t11 = <p className={styles.period}>{t10}</p>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t7 || $[29] !== t9) {
    t12 = <div className={styles.copy}>{t7}{t9}{t11}</div>;
    $[27] = t11;
    $[28] = t7;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const t13 = promo.href;
  let t14;
  if ($[31] !== locale || $[32] !== promo.ctaKey) {
    t14 = t(locale, promo.ctaKey);
    $[31] = locale;
    $[32] = promo.ctaKey;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14) {
    t15 = <span>{t14}</span>;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ExternalLink size={15} aria-hidden={true} />;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== onClick || $[38] !== promo.href || $[39] !== t15) {
    t17 = <a className={styles.cta} href={t13} target="_blank" rel="nofollow noopener noreferrer sponsored" onClick={onClick}>{t15}{t16}</a>;
    $[37] = onClick;
    $[38] = promo.href;
    $[39] = t15;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== locale) {
    t18 = t(locale, "promo.dismiss");
    $[41] = locale;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <X size={16} aria-hidden={true} />;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== onDismiss || $[45] !== t18) {
    t20 = <button type="button" className={styles.close} onClick={onDismiss} aria-label={t18}>{t19}</button>;
    $[44] = onDismiss;
    $[45] = t18;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t17 || $[48] !== t20) {
    t21 = <div className={styles.actions}>{t17}{t20}</div>;
    $[47] = t17;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t12 || $[51] !== t21 || $[52] !== t5) {
    t22 = <aside className={styles.banner} aria-label={t5}>{t12}{t21}</aside>;
    $[50] = t12;
    $[51] = t21;
    $[52] = t5;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  return t22;
}
export function PromoBanner(t0) {
  const $ = _c(7);
  const {
    locale
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== locale) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const active = getActivePromos();
      if (active.length === 0) {
        t3 = null;
        break bb0;
      }
      t1 = styles.stack;
      t2 = active.map(promo => <PromoBannerItem key={promo.id} promo={promo} locale={locale} />);
    }
    $[0] = locale;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}